/* An Event's status, as a badge — STORY-011.
 *
 * The five from `glossary.md`, and the map is explicit rather than built as
 * `t(\`events.status.\${status}\`)`: `i18n.md` forbids a dynamically constructed
 * key because it defeats extraction and unused-key detection, and names an
 * explicit map as the alternative.
 *
 * Colour is never the only signal. Each badge carries its word, so a reader who
 * cannot distinguish the tones still knows which status it is — `design.md`.
 */

import type { EventStatus } from '@eventuley/contracts';
import type { MessageKey } from '@eventuley/i18n';
import { useTranslate } from '../../../shared/i18n/index.js';

const LABELS = {
  idea: 'events.status.idea',
  planned: 'events.status.planned',
  confirmed: 'events.status.confirmed',
  completed: 'events.status.completed',
  cancelled: 'events.status.cancelled',
} as const satisfies Record<EventStatus, MessageKey>;

/* Idea is the quiet one on purpose: most of the list is ideas, and a wall of
 * colour says nothing. The tones that mean something are the committed ones. */
const TONES = {
  idea: 'badge badge--draft',
  planned: 'badge badge--info',
  confirmed: 'badge badge--positive',
  completed: 'badge badge--neutral',
  cancelled: 'badge badge--danger',
} as const satisfies Record<EventStatus, string>;

export function EventStatusBadge({ status }: { readonly status: EventStatus }) {
  const t = useTranslate();

  return <span className={TONES[status]}>{t(LABELS[status])}</span>;
}
